import { createDuoToneIcon } from './helpers/createDuoToneIcon'

export const InfoDuoTone = createDuoToneIcon(
  'InfoDuoTone',
  [
    [
      'path',
      {
        d: 'M12 1.625C14.2144 1.625 15.9637 1.62308 17.3291 1.80664C18.7194 1.99362 19.8423 2.38729 20.7275 3.27246C21.6127 4.15766 22.0064 5.2806 22.1934 6.6709C22.3769 8.03624 22.375 9.78557 22.375 12C22.375 14.2142 22.3769 15.9628 22.1934 17.3281C22.0181 18.6317 21.6611 19.7006 20.8877 20.5586L20.7275 20.7275C19.8422 21.6128 18.7186 22.0064 17.3281 22.1934C15.9628 22.3769 14.2142 22.375 12 22.375C9.78557 22.375 8.03624 22.3769 6.6709 22.1934C5.2806 22.0064 4.15766 21.6127 3.27246 20.7275C2.38729 19.8423 1.99362 18.7194 1.80664 17.3291C1.62308 15.9637 1.625 14.2144 1.625 12C1.625 9.78557 1.62308 8.03625 1.80664 6.6709C1.99362 5.28059 2.38727 4.15766 3.27246 3.27246C4.15766 2.38727 5.28059 1.99362 6.6709 1.80664C8.03625 1.62308 9.78557 1.625 12 1.625ZM12 10.625C11.5168 10.625 11.125 11.0168 11.125 11.5V16C11.125 16.4832 11.5168 16.875 12 16.875C12.4832 16.875 12.875 16.4832 12.875 16V11.5C12.875 11.0168 12.4832 10.625 12 10.625ZM12 7.12695C11.5168 7.12695 11.125 7.51871 11.125 8.00195V8.01172C11.1251 8.49486 11.5168 8.88672 12 8.88672C12.4832 8.88672 12.8749 8.49486 12.875 8.01172V8.00195C12.875 7.51871 12.4832 7.12695 12 7.12695Z',
        stroke: 'none',
        key: 'InfoDuoTone-0',
      },
    ],
  ],
  {
    defaultGradient: 'navy',
    defaultForegroundClassName: 'fill-background',
  },
)

InfoDuoTone.displayName = 'InfoDuoTone'
